import React, { useState, useEffect } from 'react';
import styles from './CookiesPopup.module.scss';

import { useTranslation } from 'react-i18next';
import { useCookies } from 'react-cookie';

export const CookiesPopup = () => {
  const [cookies, setCookie] = useCookies(['cookies_accepted']);
  const [printPopup, setPrintPopup] = useState<boolean>(true);
  const { t } = useTranslation();
  const IS_HIDDEN_LOCATIONS: string[] = [];
  const path = window.location.pathname;
  const isHiddenLocation = IS_HIDDEN_LOCATIONS.some((substring) =>
    path.includes(substring),
  );
  const now = new Date();
  const expires = new Date(
    now.getFullYear() + 1,
    now.getMonth(),
    now.getDate(),
  );
  useEffect(() => {
    const areCookiesAccepted = Boolean(cookies['cookies_accepted']);

    if (areCookiesAccepted === true) {
      setPrintPopup(false);
    } else if (areCookiesAccepted === undefined && !isHiddenLocation) {
      setPrintPopup(true);

      setCookie('cookies_accepted', false, {
        path: '/',
        expires,
      });
    } else if (isHiddenLocation) {
      setPrintPopup(false);
    } else {
      setPrintPopup(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const acceptCookies = () => {
    // removeCookie('cookies_accepted');
    setCookie('cookies_accepted', true, {
      path: '/',
      expires,
    });
    setPrintPopup(false);
  };

  return (
    <>
      {printPopup && (
        <div className={styles.container}>
          <p>
            {t('cookies_info1')} "
            <a //eslint-disable-line
              href="#"
              className={styles.anchor}
            >
              {t('privacy_preferences')}
            </a>
            " {t('cookies_info2')}
          </p>
          <div className={styles.cookiesBtn} onClick={acceptCookies}>
            OK
          </div>
        </div>
      )}
    </>
  );
};
